import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useVideoService() {
    const { authenticatedFetch, authenticatedFormFetch } = useApi();

    // Envia FormData (com arquivos)
    const criarVideo = async (formData) => {
        const response = await authenticatedFormFetch(URLS.CREATE_VIDEO, formData);
        return response.json();
    };

    // Envia FormData (com arquivos)
    const atualizarVideo = async (formData) => {
        const response = await authenticatedFormFetch(URLS.UPDATE_VIDEO, formData);
        return response.json();
    };

    const deletarVideo = async (id) => {
        const response = await authenticatedFetch(URLS.DELETE_VIDEO, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const obterVideoPorId = async (id) => {
        const response = await authenticatedFetch(URLS.READ_VIDEO_BY_ID, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const listarVideos = async () => {
        const response = await authenticatedFetch(URLS.READ_ALL_VIDEO, {
            method: 'POST',
        });

        return response.json();
    };

    const listarProdutosDoVideo = async (idVideo) => {
        const response = await authenticatedFetch(URLS.READ_PRODUTO_VIDEO_BY_VIDEO_ID, {
            method: 'POST',
            body: JSON.stringify({ idVideo }),
        });

        return response.json();
    };

    const deletarProdutoDoVideo = async (idVideo, idProduto) => {
        const response = await authenticatedFetch(URLS.DELETE_PRODUTO_VIDEO, {
            method: 'POST',
            body: JSON.stringify({ idVideo, idProduto }),
        });

        return response.json();
    };

    return {
        criarVideo,
        atualizarVideo,
        deletarVideo,
        obterVideoPorId,
        listarVideos,
        listarProdutosDoVideo,
        deletarProdutoDoVideo,
    };
}